import { PersonInfo } from './person';

export enum AssessmentStatus {
  Success = 'APPNP', // used by NAC
  Declined = 'DECNP',
  NoAdditionalPremiumPayable = 'APPNP',
  AdditionalPremiumPayable = 'APPPP',
}

export interface Assessment {
  id: string;
  conditions: string[];
  outcome: string;
  price?: number;
  screeningRecord?: any;
  pricingOption?: any;
  calculationOption?: any
  status: string;
  isComplete?: boolean;
}

export interface TravellerAssessment {
  id: string;
  person: PersonInfo | null;
  assessment?: Assessment;
}
